import { get, patch, del, post, upload } from '../../utils/api'
import { AxiosResponse } from 'axios'

export const fetchCourse = (id: string): Promise<AxiosResponse> =>
  get(`/courses/courses/${id}`, {
    include: [
      'modules',
      'modules.moduleScreens',
      'modules.lessons',
      'maps',
      'maps.imageMedia',
    ].join(','),
  })

export const fetchThemes = (id: string): Promise<AxiosResponse> =>
  get(`/courses/courses/${id}/themes`)

export const editCourse = (
  id: string,
  title: string,
  status: string,
  starts_at: string,
  auto_subscription: boolean
): Promise<AxiosResponse> =>
  patch(`/courses/courses/${id}`, {
    title,
    status,
    starts_at,
    auto_subscription,
  })

export const removeCourse = (id: string): Promise<AxiosResponse> =>
  del(`/courses/courses/${id}`)

export const fetchCourseStatistic = (id: string): Promise<AxiosResponse> =>
  get(`/courses/courses/${id}/statistic`)

export const createTheme = (
  id: string,
  title: string,
  color: string
): Promise<AxiosResponse> =>
  post('/courses/themes', {
    course_id: id,
    title,
    color,
  })

export const editTheme = (
  themeId: string,
  title: string,
  color: string
): Promise<AxiosResponse> =>
  patch(`/courses/themes/${themeId}`, {
    title,
    color,
  })

export const removeTheme = (id: string): Promise<AxiosResponse> =>
  del(`/courses/themes/${id}`)

export const createMap = (
  course_id: string,
  image: File,
  is_active: boolean
): Promise<AxiosResponse> =>
  upload(
    '/courses/maps',
    {
      field: 'image',
      item: image,
    },
    {
      course_id,
      is_active,
    }
  )

export const removeMap = (id: string): Promise<AxiosResponse> =>
  del(`/courses/maps/${id}`)
